module.exports = __webpack_public_path__ + "static/media/bucklefront.45a8b8ee.png";